var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '../../utils/style-class.utils';
import ActionListItem from './components/action-list-item/action-list-item';
import AlertListItem from './components/alert-list-item/alert-list-item';
import MenuListItem from './components/menu-list-item/menu-list-item';
import TitleListItem from './components/title-list-item/title-list-item';
import UserAlertListItem from './components/user-alert-list-item/user-alert-list-item';
export var StackedList = function (_a) {
    var type = _a.type, listItems = _a.listItems, className = _a.className, _b = _a.isFullHeight, isFullHeight = _b === void 0 ? true : _b, id = _a.id, onScroll = _a.onScroll, onClickItem = _a.onClickItem;
    var getItemComponent = function (type, item, index, id) {
        switch (type) {
            case 'ActionList':
                return (_jsx(ActionListItem, { item: item, id: 'actionList' + index, onClickItem: onClickItem }, item.title + '-stackedList-listItem-' + index));
            case 'MenuList':
                return (_jsx(MenuListItem, { item: item, onClickItem: onClickItem }, item.title + '-stackedList-listItem-' + index));
            case 'TitleList':
                return (_jsx(TitleListItem, { item: item, onClickItem: onClickItem }, item.title + '-stackedList-listItem-' + index));
            case 'UserAlertList':
                return (_jsx(UserAlertListItem, { item: item, onClickItem: onClickItem }, item.title + '-stackedList-listItem-' + index));
            case 'AlertList':
                return (_jsx(AlertListItem, { item: item, onClickItem: onClickItem }, item.title + '-stackedList-listItem-' + index));
            default:
                return _jsx("div", {});
        }
    };
    var handleScroll = function (e) {
        var element = e.target;
        if (onScroll && element.scrollTop) {
            onScroll(element.scrollTop);
        }
    };
    return (_jsx("div", __assign({ className: classNames(className, isFullHeight ? 'h-full' : '', 'flex-1 overflow-auto'), onScroll: function (e) { return handleScroll(e); } }, { children: listItems.map(function (item, idx) { return getItemComponent(type, item, idx, id); }) })));
};
export default StackedList;
//# sourceMappingURL=stacked-list.js.map